import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Never retry a definite answer: 401/403 (auth), 404 (not there), and
      // 429 above all — retrying a rate limit spends the budget that is
      // already exhausted and makes the burst worse.
      retry: (failureCount, err) => {
        const status = err?.response?.status;
        if (status === 401 || status === 403 || status === 404 || status === 429) return false;
        return failureCount < 1;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

export default queryClient;
